import React from "react";
import {Tooltip} from "antd";
export const Shortener = ({
    text,
    length = 10,
    showTitle = true,
    render = text => text,
    moreText = "...",
    zIndex
}) => {
    if (!text) {
        return "-";
    }
    return (
        <Tooltip title={showTitle ? text : ""} zIndex={zIndex}>
            {render(text?.length <= length ? text : `${text?.slice(0, length)}${moreText}`)}
        </Tooltip>
    );
};
